import {Component} from "react";
import request from "request-promise-native";
import Modal from "react-responsive-modal";
import Alert from "react-bootstrap/lib/Alert";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Button from "react-bootstrap/lib/Button";
import React from "react";

const REBOOT_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMReboot";

class RebootDeviceConfirmModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - device
             - open
             - onClose
             - onDeviceReboot
             - logout
        */
        super(props);
        this.state = {
            success: false
        };
    }

    async submit() {
        this.setState({loading: true, errorMessage:null});

        const device = this.props.device;

        const options = {
            method: 'POST',
            uri: REBOOT_DEVICE_ENDPOINT,
            body: {
                access_code: this.props.access_code,
                regId: this.props.device.regId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        this.setState({loading: false});

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        if(response.statusCode===400) {
            this.setState({errorMessage: response.body.msg});
            return;
        }

        if(response.statusCode!==200) {
            this.setState({errorMessage: 'Server error occured, please retry.'});
            return;
        }

        this.setState({
            success: true,
            expectedAt: response.body.expectedAt
        });

        //Success
        this.props.onDeviceReboot(device);
    }

    reset() {
        this.setState({
            success: false,
            loading: false,
            errorMessage: null
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Reboot device</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}
                {this.state.loading ? (
                    <div>
                        <p>Loading...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Reboot request submitted!</p>
                        {this.state.expectedAt!=null && this.state.expectedAt>Date.now() ? (
                            <div>
                                <p>Reboot expected at {new Date(this.state.expectedAt).toLocaleString()} (in {Math.floor((this.state.expectedAt-Date.now())/(60*1000))} minutes)</p>
                            </div>
                        ) : ""}
                    </div>
                ) : (
                    <div>
                        <p>Do you really want to reboot this device?</p>

                        <Button bsStyle="success" className='mr-2' disabled={this.state.loading} onClick={this.submit.bind(this)}>
                            Yes
                        </Button>

                        <Button bsStyle="danger" disabled={this.state.loading} onClick={this.reset.bind(this)}>
                            No
                        </Button>
                    </div>)}


            </Modal>
        );
    }
}

export default RebootDeviceConfirmModal;